if (!customElements.get('secondary-images')) {
  class SecondaryImages extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  get template() {
    return this._template = this._template || this.querySelector(':scope > template')
  }

  get container() {
    return this._container = this._container || this.querySelector('[data-swiper-container]') || this.querySelector('.swiper')
  }

  get wrapper() {
    return this._wrapper = this._wrapper || this.querySelector('[data-swiper-wrapper]') || this.querySelector('.swiper-wrapper')
  }

  get pagination() {
    return this.querySelector(`#Pagination-Slider-${this.dataset.sliderId}`)
      || this.querySelector('.swiper-pagination')
      || document.querySelector(`#Pagination-Slider-${this.dataset.sliderId}`);
  }

  get prev() {
    return this.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-prev`)
      || this.querySelector('.swiper-button-prev')
      || document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-prev`);
  }

  get next() {
    return this.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-next`)
      || this.querySelector('.swiper-button-next')
      || document.querySelector(`#Navigation-Slider-${this.dataset.sliderId} .swiper-button-next`);
  }

  connectedCallback() {
    this.createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: this.threshold
    });
  }

  disconnectedCallback() {
    // code here
  }

  createObserver(options) {
	  const threshold = options.threshold ? options.threshold : 0;
	  const observer = new IntersectionObserver((entries, observer) => {
	    entries.forEach(entry => {
	      if (entry.isIntersecting) {
	        if (typeof options.callback === 'function') {
	          options.callback();
	          observer.unobserve(entry.target);
	        }
	      }
	    });
	  }, { rootMargin: `0px 0px ${threshold}px 0px` });
	  observer.observe(options.element);
	}

  init() {
    if(this.hasAttribute('loaded')) return;
    this.template.replaceWith(this.template.content.firstElementChild.cloneNode(true));
    this.options = this.swiperOptions();
    if (!this.swiper) this.swiperInitilize();
    this.bindLinkClick();
    this.setAttribute('loaded', true);
    this.dispatchEvent(new CustomEvent('secondary-images:loaded', { bubbles: true }));
  }

  bindEvents() {
    if (!this.swiper) return;

      this.blockParentSwipe();

  
    this._onSlideChange = () => {
      this.swiper.pagination?.update?.();
  this.swiper.navigation?.update?.();

      this.dispatchEvent(new CustomEvent('slider:change', {
        bubbles: true,
        detail: { currentPage: this.swiper.activeIndex }
      }));
    };
  
    this._onTransitionStart = () => {
      this.swiper.mousewheel.enabled = false;
    };
  
    this._onTransitionEnd = () => {
      this.swiper.mousewheel.enabled = true;
    };

    this.swiper.on('slideChange', this._onSlideChange);
    this.swiper.on('transitionStart', this._onTransitionStart);
    this.swiper.on('transitionEnd', this._onTransitionEnd);
  }
  
  unBindEvents() {
    if (!this.swiper) return;
  
    this.swiper.off('slideChange', this._onSlideChange);
    this.swiper.off('transitionStart', this._onTransitionStart);
    this.swiper.off('transitionEnd', this._onTransitionEnd);
  
    this._onSlideChange = null;
    this._onTransitionStart = null;
    this._onTransitionEnd = null;
  }

  bindLinkClick() {
    if (this._linkClickBound) return;
    this._linkClickBound = true;

    this.addEventListener('click', (e) => {
      const img = e.target.closest('img');
      if (!img) return;

      const link = this.querySelector('a.secondary-images__link[href]');
      if (!link) return;

      if (e.target.closest('.swiper-button, .swiper-pagination')) return;

      link.click();
    }, true);
  }


  swiperOptions() {
    let defaultOptions = {};
    try {
      defaultOptions = JSON.parse(this.dataset.swiper || '{}');
    } catch (e) {
      console.error('Invalid JSON in data-swiper:', e);
    }
    let navigation = {
      prevEl: this.prev,
      nextEl: this.next
    };
    let pagination = {
      el: this.pagination,
      clickable: true,
      renderBullet: (index, className) => {
        return `<span class="${className}">${index + 1}</span>`;
      }
    };
    let options = { ...defaultOptions };
    options = {
      ...options,
       nested: true,
      allowTouchMove: true,
      simulateTouch: true,
      touchStartPreventDefault: false,
      touchMoveStopPropagation: true,
  touchReleaseOnEdges: false,
      passiveListeners: false,
      resistanceRatio: 0.85,
      pagination: {
        ...pagination
      },
      navigation: {
        ...navigation
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          this.checkNavigation(element);
          this.checkPagination(element);
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        },
        resize: (element) => {
          this.checkNavigation(element);
          this.checkPagination(element);
        },
        update: (element) => {
          this.checkNavigation(element);
          this.checkPagination(element);
        }
      }
    }

    return options
  }

  swiperInitilize(){
    if(!this.container.classList.contains('swiper')) this.container.classList.add('swiper');
    if(!this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.add('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if(!element.classList.contains('swiper-slide')) element.classList.add('swiper-slide')
    });
    this.swiper = new Swiper(this.container, this.options);
    this.dispatchEvent(new CustomEvent('slider:init', {
      bubbles: true,
      detail: {
        id: this.dataset.sliderId,
        swiper: this.swiper
      }
    }));
    this.bindEvents();
  }

  swiperDestroy() {
    this._blockParentSwipeCleanup?.();
  this._blockParentSwipeCleanup = null;
  
    this.unBindEvents();
    this.swiper?.destroy(true, true);
    this.swiper = null;
    if(this.container.classList.contains('swiper')) this.container.classList.remove('swiper');
    if(this.wrapper.classList.contains('swiper-wrapper')) this.wrapper.classList.remove('swiper-wrapper');
    this.querySelectorAll('[data-swiper-slide]').forEach((element) => {
      if(element.classList.contains('swiper-slide')) element.classList.remove('swiper-slide')
    });
    this.dispatchEvent(new CustomEvent('slider:destroy', {
      bubbles: true,
      detail: {
        id: this.dataset.sliderId
      }
    }));
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if (!pagination.el || pagination.bullets.length == 1) return;
    this.classList.add('has-pagination');
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    this.classList.add('has-navigation');
  }

  blockParentSwipe() {
    const el = this.container || this;
    if (!el) return;

    const mq = window.matchMedia('(max-width: 1032px)');

    const attach = () => {
      if (this._blockParentSwipeCleanup) return;

      const stop = (e) => e.stopPropagation();

      el.addEventListener('touchstart', stop, { passive: true });
      el.addEventListener('touchmove',  stop, { passive: true });
      el.addEventListener('pointerdown', stop);
      el.addEventListener('pointermove', stop);

      this._blockParentSwipeCleanup = () => {
        el.removeEventListener('touchstart', stop);
        el.removeEventListener('touchmove', stop);
        el.removeEventListener('pointerdown', stop);
        el.removeEventListener('pointermove', stop);
        this._blockParentSwipeCleanup = null;
      };
    };

    const detach = () => {
      this._blockParentSwipeCleanup?.();
    };

    const apply = () => {
      if (mq.matches) attach();
      else detach();
    };

    apply();

    this._blockParentSwipeMQ = mq;
    this._blockParentSwipeMQHandler = apply;

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else mq.addListener(apply);
  }

}

customElements.define('secondary-images', SecondaryImages);
}